import { createSlice } from '@reduxjs/toolkit';
import LoadingStatus from 'enums/loadingStatus';
import { camelCaseObjectKeys } from 'utils/camelCase';
import initialState from './initialState';

const housingProductLocationContentSlice = createSlice({
  name: 'housingProductLocationContent',
  initialState,
  reducers: {
    fetch: (state) => {
      state.fetchStatus = LoadingStatus.Loading;
    },
    fetchFulfilled: (state, action) => {
      const payload = camelCaseObjectKeys(action.payload);
      state.fetchStatus = LoadingStatus.Succeeded;
      state.title = payload.title;
      state.metaDescription = payload.metaDescription;
      state.metaRobots = payload.metaRobots;
      state.canonical = payload.canonical;
      state.heading1 = payload.heading1;
      state.heading2 = payload.heading2;
      state.footer = payload.footer;
    },
    fetchError: (state) => {
      state.fetchStatus = LoadingStatus.Failed;
    },
  },
});

// Extract the action creators object and the reducer
export default housingProductLocationContentSlice;
